import { render } from "./ArticleComments.vue?vue&type=template&id=5a7e1808&scoped=true"
import script from "./ArticleComments.vue?vue&type=script&lang=js"
export * from "./ArticleComments.vue?vue&type=script&lang=js"

import "./ArticleComments.vue?vue&type=style&index=0&id=5a7e1808&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5a7e1808"

export default script